import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { CompanyRevenue } from "../../pages/ManageCompanyRevenue/schema/company-revenue";

import { CompanyRevenueApi } from "./company-revenue.api";

const initialState: CompanyRevenue[] = [];

export const companyRevenueSlice = createSlice({
	name: "company-revenue",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(
			CompanyRevenueApi.endpoints.getCompanyRevenues.matchFulfilled,
			(_, { payload }) => payload ?? []
		);
		builder.addMatcher(
			CompanyRevenueApi.endpoints.createCompanyRevenue.matchFulfilled,
			(state, { payload }) => {
				if (payload?.id) {
					return [...state, payload];
				}

				return state;
			}
		);
		builder.addMatcher(
			CompanyRevenueApi.endpoints.updateCompanyRevenue.matchFulfilled,
			(state, { payload }) => {
				const index = state.findIndex((i) => i.id === payload.id);

				if (index !== -1) {
					state[index] = payload;
				}

				return state;
			}
		);
		builder.addMatcher(
			CompanyRevenueApi.endpoints.deleteCompanyRevenue.matchFulfilled,
			(_, { payload }) => payload ?? []
		);
	},
});

export const companyRevenueReducer = companyRevenueSlice.reducer;
export const companyRevenueSelector = (state: RootState) => state[companyRevenueSlice.name];
